import React from "react";
import {
  Box,
  Card,
  CardContent,
  LinearProgress,
  Skeleton,
  Typography,
} from "@mui/material";
import { Business } from "@mui/icons-material";
import { COLORS } from "./constants";

const RANK_COLORS = [
  COLORS.indigo,
  "#26a69a",
  "#ffa726",
  "#66bb6a",
  "#ab47bc",
];

export default function TopCompaniesPanel({ stats = [], isLoading }) {
  const max = stats.length > 0 ? Math.max(...stats.map((s) => s.call_count), 1) : 1;

  return (
    <Card sx={{ borderRadius: "16px", boxShadow: "0 2px 12px rgba(0,0,0,0.07)", height: "100%" }}>
      <CardContent sx={{ p: 2.5, pb: "12px !important" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight={700} sx={{ fontSize: "0.95rem" }}>
            Top Contacted Accounts
          </Typography>
          <Business sx={{ fontSize: 20, color: "text.disabled" }} />
        </Box>

        {isLoading ? (
          Array.from({ length: 5 }).map((_, i) => (
            <Box key={i} mb={2}>
              <Box display="flex" justifyContent="space-between" mb={0.5}>
                <Skeleton variant="text" width="55%" />
                <Skeleton variant="text" width="20%" />
              </Box>
              <Skeleton variant="rectangular" height={6} sx={{ borderRadius: 3 }} />
            </Box>
          ))
        ) : stats.length === 0 ? (
          <Box py={4} textAlign="center">
            <Business sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
            <Typography variant="body2" color="text.secondary">
              No account call data for this period
            </Typography>
          </Box>
        ) : (
          <Box>
            {stats.map((item, idx) => (
              <Box key={item.company_id ?? idx} mb={2}>
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: "6px",
                        bgcolor: RANK_COLORS[idx] + "22",
                        color: RANK_COLORS[idx],
                        fontWeight: 800,
                        fontSize: "0.72rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      {idx + 1}
                    </Box>
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      noWrap
                      sx={{ maxWidth: 150, fontSize: "0.82rem" }}
                    >
                      {item.company_name}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body2"
                    fontWeight={700}
                    sx={{ color: RANK_COLORS[idx], fontSize: "0.82rem", ml: 1, flexShrink: 0 }}
                  >
                    {item.call_count} calls
                  </Typography>
                </Box>
                <LinearProgress
                  variant="determinate"
                  value={(item.call_count / max) * 100}
                  sx={{
                    height: 6,
                    borderRadius: 3,
                    bgcolor: RANK_COLORS[idx] + "22",
                    "& .MuiLinearProgress-bar": {
                      borderRadius: 3,
                      bgcolor: RANK_COLORS[idx],
                    },
                  }}
                />
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
